import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CustomError } from 'pricing-pages-lib/errors/CustomErrors';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import Raven from 'raven-js';
import { useMemo } from 'react';
import { RECURRING } from 'self-service-api/constants/ChargeTypes';
import { BREEZE_INTELLIGENCE_CREDITS } from 'self-service-api/constants/UnitNames';
import { BREEZE_CARD } from '../../constants/tracking/TrackingSources';
import { useCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { AddOnCardPricingFallback } from './AddOnCardFallbacks';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeCardPricing = ({
  productConfigurations,
  skuId,
  term
}) => {
  var _includedCredits$quan;
  const currencyCode = useDisplayedCurrencyCode();
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const isRecurring = product && product.chargeType === RECURRING;
  const {
    monthlyCalculatedPrice,
    oneTimeFeeCalculatedPrice,
    loading,
    error
  } = useCalculatedPrice({
    apiName: product.apiName,
    queryParamTerm: term
  });
  const price = useMemo(() => {
    var _productConfiguration, _productConfiguration2;
    const selectedQuantity = (_productConfiguration = (_productConfiguration2 = productConfigurations.find(config => config.skuId === skuId)) === null || _productConfiguration2 === void 0 ? void 0 : _productConfiguration2.quantity) !== null && _productConfiguration !== void 0 ? _productConfiguration : 1;
    if (monthlyCalculatedPrice && isRecurring) {
      return monthlyCalculatedPrice * selectedQuantity;
    } else if (oneTimeFeeCalculatedPrice && !isRecurring) {
      return oneTimeFeeCalculatedPrice * selectedQuantity;
    }
    if (!monthlyCalculatedPrice && !oneTimeFeeCalculatedPrice) {
      Raven.captureException(new CustomError('BreezeCardPricing: No pricing data found for product', {
        error
      }));
    }
  }, [isRecurring, monthlyCalculatedPrice, oneTimeFeeCalculatedPrice, productConfigurations, skuId, error]);
  const includedCredits = product.currentVersion.includedUnits.find(({
    name
  }) => name === BREEZE_INTELLIGENCE_CREDITS);
  if (!price && !loading) {
    return /*#__PURE__*/_jsx(AddOnCardPricingFallback, {});
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20],
    widths: ['100%'],
    children: price && /*#__PURE__*/_jsx("div", {
      "data-selenium-id": `${BREEZE_CARD}-${product.apiName}-price`,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `planBuilder.priceDisplay.perMonthPerXCredits`,
        options: {
          price: /*#__PURE__*/_jsx(PriceDisplay, {
            price: price,
            currencyCode: currencyCode
          }),
          count: /*#__PURE__*/_jsx(FormattedNumber, {
            value: (_includedCredits$quan = includedCredits === null || includedCredits === void 0 ? void 0 : includedCredits.quantity) !== null && _includedCredits$quan !== void 0 ? _includedCredits$quan : 0
          })
        }
      })
    })
  });
};